import { render, staticRenderFns } from "./GlassBreakageSecurityQuestion.vue?vue&type=template&id=924b583c&scoped=true"
import script from "./GlassBreakageSecurityQuestion.vue?vue&type=script&lang=ts"
export * from "./GlassBreakageSecurityQuestion.vue?vue&type=script&lang=ts"
import style0 from "./GlassBreakageSecurityQuestion.vue?vue&type=style&index=0&id=924b583c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b583c",
  null
  
)

export default component.exports